import React, { useState } from 'react';
import CreatedCharacterModal from './CreatedCharacterModal';
import { CharacterContextProvider } from './CharacterContext';
import CharacterCreationPageContent from './CharacterCreationPageContent';

const CharacterCreationPage: React.FC = () => {
  const [showCreatedCharacterModal, setShowCreatedCharacterModal] =
    useState(false);

  return (
    <CharacterContextProvider>
      <CharacterCreationPageContent
        setShowCreatedCharacterModal={setShowCreatedCharacterModal}
      />

      <CreatedCharacterModal
        show={showCreatedCharacterModal}
        setShow={setShowCreatedCharacterModal}
      />
    </CharacterContextProvider>
  );
};

export default CharacterCreationPage;
